import {
  CHAT_COMPLIANCE,
  CHAT_COMPLIANCE_LOG,
  CHAT_COMPLIANCE_SEARCH,
} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {complianceGuard} from '@modules/chat-compliance/RequireCompliance'

/**
 * The company admin's read-only conversation review, on the standard layout. Guarded by asking the
 * server (COMPANY_ADMIN AND the explicit CHAT_COMPLIANCE grant): the usual feature check would let
 * every admin in.
 */
export const ChatComplianceRoutes: IAppRoutes[] = [
  {
    link: CHAT_COMPLIANCE,
    element: complianceGuard(() => import('@modules/chat-compliance/conversations')),
  },
  {
    link: CHAT_COMPLIANCE_SEARCH,
    element: complianceGuard(() => import('@modules/chat-compliance/search')),
  },
  {
    link: CHAT_COMPLIANCE_LOG,
    element: complianceGuard(() => import('@modules/chat-compliance/access-log')),
  },
  {
    link: CHAT_COMPLIANCE + '/:id',
    element: complianceGuard(() => import('@modules/chat-compliance/transcript')),
  },
]
